export default {
  async execute(client) {
    return {
      id: client.id,
      first_name: client.firstName,
      last_name: client.lastName,
      email: client.email,
      phone: client.phone,
      invited_at: client.invitedAt,
      joined_at: client.joinedAt,
      assets: client.assets,
      fee: client.fee,
    };
  },
};
